// Fetches today's vegetable wholesale prices from CMDA Chennai via r.jina.ai,
// which renders the page server-side and returns plain text/markdown with CORS headers.
// No backend or proxy required.

const parseNumber = (raw) => {
  if (raw === null || raw === undefined) return null;
  const num = parseFloat(String(raw).replace(/[^\d.]/g, ''));
  return isNaN(num) ? null : num;
};

const splitName = (raw) => {
  if (!raw) return { nameEn: '', nameTa: '' };
  const m = raw.match(/^([^()]+?)\s*\(([^)]+)\)\s*$/);
  if (m) return { nameEn: m[1].trim(), nameTa: m[2].trim() };
  return { nameEn: raw.trim(), nameTa: '' };
};

const extractDate = (text) => {
  const m = text.match(/Date\s*[:\-]?\s*(\d{1,2}[-/]\d{1,2}[-/]\d{2,4})/i);
  return m ? m[1] : '';
};

// Parses a markdown table block. Looks for lines like:
// | Bangalore Tomato (பெங்களூர் தக்காளி) | 35 | 42 | 1 Kg |
const parseMarkdownTable = (text) => {
  const lines = text.split(/\r?\n/);
  const items = [];
  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed.startsWith('|') || !trimmed.endsWith('|')) continue;
    // Skip header separator like | --- | --- |
    if (/^\|[\s\-:|]+\|$/.test(trimmed)) continue;

    const cells = trimmed
      .slice(1, -1)
      .split('|')
      .map((c) => c.trim());
    if (cells.length < 3) continue;

    // Need a name + at least two numeric-looking cells
    const name = cells[0];
    const min = parseNumber(cells[1]);
    const max = parseNumber(cells[2]);
    const unit = cells[3] || '';

    // Skip header row ("Commodity | Min Price | Max Price | Units")
    if (min === null && max === null) continue;
    if (!name || /^commodity$/i.test(name)) continue;

    const { nameEn, nameTa } = splitName(name);
    items.push({
      nameEn,
      nameTa,
      minPrice: min,
      maxPrice: max ?? min,
      unit: unit || '1 Kg',
    });
  }
  return items;
};

export const fetchCmdaPrices = async () => {
  const TARGET = 'https://www.cmdachennai.gov.in/Commodity/Index';
  const res = await fetch(`https://r.jina.ai/${encodeURIComponent(TARGET)}`, {
    headers: {
      Accept: 'text/plain',
      'X-Return-Format': 'markdown',
    },
  });
  if (!res.ok) {
    throw new Error(`Failed to load CMDA prices (${res.status})`);
  }
  const text = await res.text();

  const items = parseMarkdownTable(text);
  const date = extractDate(text);
  return { items, date };
};
